import { useTranslation } from "react-i18next";

const team = [
  {
    name: "Kofi Mensah",
    roleKey: "Founder & Editorial Director",
    roleFr: "Fondateur & Directeur Éditorial",
    origin: "Ghana",
    flag: "🇬🇭",
    bioEn: "Journalist and entrepreneur, Kofi founded Wazi Stories after realizing that African media wasn't telling enough of the continent's success stories. 10 years of experience in digital media.",
    bioFr: "Journaliste et entrepreneur, Kofi a fondé Wazi Stories après avoir réalisé que les médias africains ne racontaient pas assez les réussites du continent. 10 ans d'expérience dans les médias digitaux.",
    image: "https://public.readdy.ai/ai/img_res/acc76daca3d994a247c7008c6f323cf7.jpg",
    linkedin: "#",
    twitter: "#",
  },
  {
    name: "Aminata Coulibaly",
    roleKey: "Content Director",
    roleFr: "Directrice des Contenus",
    origin: "Côte d'Ivoire",
    flag: "🇨🇮",
    bioEn: "Former editor-in-chief at Jeune Afrique, Aminata oversees the editorial quality of all stories published on the platform. Passionate about African women entrepreneurs.",
    bioFr: "Ancienne rédactrice en chef chez Jeune Afrique, Aminata supervise la qualité éditoriale de toutes les histoires publiées sur la plateforme. Passionnée par les femmes entrepreneures africaines.",
    image: "https://readdy.ai/api/search-image?query=young%20ivorian%20african%20woman%20journalist%20editor%20professional%20confident%20warm%20smile%20modern%20portrait%20studio%20Abidjan%20background&width=400&height=400&seq=team2&orientation=squarish",
    linkedin: "#",
    twitter: "#",
  },
  {
    name: "Seun Adeyemi",
    roleKey: "Tech & Product Lead",
    roleFr: "Responsable Tech & Produit",
    origin: "Nigeria",
    flag: "🇳🇬",
    bioEn: "Full-stack developer and product manager, Seun built the technical platform of Wazi Stories. Former engineer at Flutterwave, he believes in the power of tech to promote African talent.",
    bioFr: "Développeur full-stack et product manager, Seun a construit la plateforme technique de Wazi Stories. Ancien ingénieur chez Flutterwave, il croit au pouvoir de la tech pour valoriser les talents africains.",
    image: "https://readdy.ai/api/search-image?query=young%20nigerian%20african%20man%20software%20engineer%20tech%20product%20manager%20professional%20confident%20modern%20portrait%20Lagos%20background&width=400&height=400&seq=team3&orientation=squarish",
    linkedin: "#",
    twitter: "#",
  },
  {
    name: "Fatou Diallo",
    roleKey: "Community & Social Media Manager",
    roleFr: "Responsable Communauté & Réseaux",
    origin: "Sénégal",
    flag: "🇸🇳",
    bioEn: "Expert in community management and digital marketing, Fatou manages the Wazi Stories community on WhatsApp, Instagram and LinkedIn. She grew the community from 0 to 120,000 members in 2 years.",
    bioFr: "Experte en community management et marketing digital, Fatou anime la communauté Wazi Stories sur WhatsApp, Instagram et LinkedIn. Elle a fait passer la communauté de 0 à 120 000 membres en 2 ans.",
    image: "https://readdy.ai/api/search-image?query=young%20senegalese%20african%20woman%20community%20manager%20social%20media%20marketing%20professional%20confident%20warm%20smile%20modern%20portrait%20Dakar&width=400&height=400&seq=team4&orientation=squarish",
    linkedin: "#",
    twitter: "#",
  },
  {
    name: "Yves Nkurunziza",
    roleKey: "East Africa Correspondent",
    roleFr: "Correspondant Afrique de l'Est",
    origin: "Rwanda",
    flag: "🇷🇼",
    bioEn: "Based in Kigali, Yves covers the entrepreneurial ecosystem of East Africa. He has interviewed more than 200 Kenyan, Rwandan and Ethiopian entrepreneurs for Wazi Stories.",
    bioFr: "Basé à Kigali, Yves couvre l'écosystème entrepreneurial de l'Afrique de l'Est. Il a interviewé plus de 200 entrepreneurs kényans, rwandais et éthiopiens pour Wazi Stories.",
    image: "https://readdy.ai/api/search-image?query=young%20rwandan%20african%20man%20journalist%20correspondent%20professional%20confident%20modern%20portrait%20Kigali%20Rwanda%20background%20warm&width=400&height=400&seq=team5&orientation=squarish",
    linkedin: "#",
    twitter: "#",
  },
  {
    name: "Mariam Traoré",
    roleKey: "Partnerships Manager",
    roleFr: "Responsable Partenariats",
    origin: "Mali",
    flag: "🇲🇱",
    bioEn: "Former economic development consultant, Mariam develops partnerships with incubators, investment funds and African media to amplify the reach of Wazi Stories.",
    bioFr: "Ancienne consultante en développement économique, Mariam développe les partenariats avec les incubateurs, fonds d'investissement et médias africains pour amplifier la portée de Wazi Stories.",
    image: "https://readdy.ai/api/search-image?query=young%20malian%20african%20woman%20business%20development%20partnerships%20professional%20confident%20warm%20smile%20modern%20portrait%20Bamako%20background&width=400&height=400&seq=team6&orientation=squarish",
    linkedin: "#",
    twitter: "#",
  },
];

export default function TeamSection() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === "en";

  return (
    <section className="py-20 bg-[#fdf8f3]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("apropos.team.title")}</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto">
            {t("apropos.team.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8">
          {team.map((member) => (
            <div
              key={member.name}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-orange-200 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-48 md:h-64 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-1.5">
                  <span className="text-base">{member.flag}</span>
                  <span className="text-xs font-semibold text-gray-700">{member.origin}</span>
                </div>
              </div>

              <div className="p-4 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1 group-hover:text-orange-500 transition-colors">
                  {member.name}
                </h3>
                <p className="text-orange-500 text-sm font-semibold mb-3">
                  {isEn ? member.roleKey : member.roleFr}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-4">
                  {isEn ? member.bioEn : member.bioFr}
                </p>

                <div className="flex items-center gap-2 pt-3 border-t border-gray-100">
                  <a
                    href={member.linkedin}
                    rel="nofollow noopener noreferrer"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-blue-600 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-linkedin-line text-sm"></i>
                  </a>
                  <a
                    href={member.twitter}
                    rel="nofollow noopener noreferrer"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-gray-900 hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-twitter-x-line text-sm"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Join the team CTA */}
        <div className="mt-8 md:mt-12 bg-white rounded-2xl p-5 md:p-8 border border-gray-100 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
          <div className="flex items-start gap-4 md:gap-5">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-orange-50 flex-shrink-0">
              <i className="ri-user-add-line text-orange-500 text-2xl"></i>
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">{t("apropos.team.join.title")}</h3>
              <p className="text-gray-500 text-sm">
                {t("apropos.team.join.desc")}
              </p>
            </div>
          </div>
          <a
            href="mailto:contact@wazistories.africa"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 md:px-6 py-2.5 md:py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-mail-send-line"></i>
            {t("apropos.team.join.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}
